import React, { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';

import { SourceId } from 'admin/sources/Sources';
import { ReplyProps, UserType } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';

import 'reviews2/feed/review-yeti/reply/poster/ReplyPoster.scss';

export const ReplyPoster: FunctionComponent<ReplyProps> = ({ context, reply }) => {
    const { t } = useTranslation('reviews2');
    const { author_real_name, author_user_type, responder_name } = reply;
    const { review } = context;

    return (
        <div className="r4e-review-reply-poster">
            <strong className="primary-name">
                {/* eslint-disable no-nested-ternary */}
                {author_real_name === 'system'
                    ? t('RESPONDER_NAME')
                    : author_user_type === UserType.Business
                    ? t('BUSINESS_RESPONSE')
                    : author_user_type === UserType.Customer
                    ? responder_name
                    : author_real_name}
            </strong>{' '}
            {reply.author_user_type === UserType.Business &&
            review.review_source_id === SourceId.Facebook &&
            review.page?.name ? (
                <span className="secondary-name">({review.page.name})</span>
            ) : null}
        </div>
    );
};
